import React, { Component } from 'react';
import playIcon from '../assets/play.png';

class Tracks extends Component {
  state = {
    playing: false,
    audio: null,
    playingPreviewUrl: null
  };

  playAudio = previewUrl => () => {
    if (!previewUrl) return;

    const audio = new Audio(previewUrl);

    if (!this.state.playing) {
      audio.play();
      this.setState({
        playing: true,
        audio,
        playingPreviewUrl: previewUrl
      });
    } else {
      this.state.audio.pause();

      if (this.state.playingPreviewUrl === previewUrl) {
        this.setState({ playing: false });
      } else {
        audio.play();
        this.setState({
          audio,
          playingPreviewUrl: previewUrl
        });
      }
    }
  };

  trackIcon = track => {
    if (!track.preview) {
      return <span className="track-icon">N/A</span>;
    }

    if (this.state.playing && this.state.playingPreviewUrl === track.preview) {
      return <span className="track-icon">| |</span>;
    }

    return <img className="track-icon" src={playIcon} alt="play" />;
  };

  render() {
    const { tracks } = this.props;

    if (!tracks || tracks.length === 0) {
      return null;
    }

    return (
      <div>
        {tracks.map(track => {
          const { id, title, album, preview } = track;

          return (
            <div
              key={id}
              onClick={this.playAudio(preview)}
              className="track"
            >
              <img
                src={album?.cover_medium}
                alt="track-image"
                className="track-image"
              />

              <p className="track-text">{title}</p>

              <p>{this.trackIcon(track)}</p>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Tracks;